var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconIns = function SvgIconIns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.75 2h-7.5A6.25 6.25 0 0 0 2 8.25v7.5A6.25 6.25 0 0 0 8.25 22h7.5A6.25 6.25 0 0 0 22 15.75v-7.5A6.25 6.25 0 0 0 15.75 2m4.375 13.75a4.38 4.38 0 0 1-4.375 4.375h-7.5a4.38 4.38 0 0 1-4.375-4.375v-7.5A4.38 4.38 0 0 1 8.25 3.875h7.5a4.38 4.38 0 0 1 4.375 4.375z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10m0 8.125A3.13 3.13 0 0 1 8.875 12 3.13 3.13 0 0 1 12 8.875 3.13 3.13 0 0 1 15.125 12 3.13 3.13 0 0 1 12 15.125M17.375 7.291a.666.666 0 1 0 0-1.332.666.666 0 0 0 0 1.332"
  })));
};
export default SvgIconIns;